import { render, staticRenderFns } from "./project-assignments-report.vue?vue&type=template&id=a0265164&scoped=true"
import script from "./project-assignments-report.vue?vue&type=script&lang=js"
export * from "./project-assignments-report.vue?vue&type=script&lang=js"
import style0 from "./project-assignments-report.vue?vue&type=style&index=0&id=a0265164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0265164",
  null
  
)

export default component.exports